import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import ListUi from "../../../helpers/PcPriceUi/ListUi";

import { TbClockCancel } from "react-icons/tb";
import { TbLoader } from "react-icons/tb";
import { decodeJWT } from "../../../utils";
import { pricePublicContext } from "../../../context/PublicContext/PricePublicContext/PricePublicContext";

const PcPriceView = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const token = localStorage.getItem("token");
  const roleName = decodeJWT(token)?.usertype;

  const {
    setIs_orderi,
    description,
    setDescription,
    setCustomeruser,
    product_name,
    setProduct_name,
    confirmModal,
    setConfirmModal,
    resultModal,
    setResultModal,
    data,
    setData,
    getItemsList,
    type,
    setType,
    stateWeight,
    setStateWeight,
    setBos,
    transactionId,
    statePrice,
    setStatePrice,
    stateTotal,
    setStateTotal,
    setCounter,
    handleGetItemsList,
    handlePostTransaction,
    handlePriceChange,
    handleWeightChange,
    handleTotalChange,
    addCommas,
    loading,
    setLoading,
    //* Update Product
    buyTolerance,
    setBuyTolerance,
    sellTolerance,
    setSellTolerance,
    handleChangeBuyPrice,
    handleChangeSellPrice,
    handleUpdateProduct,
    //* Is Price Close
    handleChangeBuyClosePriceProduct,
    handleChangeSellClosePriceProduct,
  } = useContext(pricePublicContext);

  const handleInitial = async () => {
    setCounter((prevCounter) => prevCounter + 1);
    await handleGetItemsList();
  };

  useEffect(() => {
    const fetchData = async () => {
      await handleInitial();
      setLoading(false);
    };
    fetchData();

    const interval = setInterval(handleInitial, 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <span className="mr-auto 2xl:w-[100%] xl:w-[95%] lg:w-[90%] py-3 absolute top-[50%] mt-10 text-black text-xl flex flex-col justify-center items-center">
        <TbLoader size={60} className="animate-spin" />
        <p>لطفا صبر کنید</p>
      </span>
    );
  }

  // ✅ مرتب‌سازی و سپس فیلتر کردن
  // ابتدا لیست را بر اساس priority_num سورت می‌کنیم (صعودی)
  const sortedItems = [...getItemsList].sort(
    (a, b) => a.priority_num - b.priority_num,
  );

  // سپس بر اساس tag فیلتر می‌کنیم
  const goldItems = sortedItems.filter((item) => item.tag === "T");
  const coinItems = sortedItems.filter((item) => item.tag === "S");

  return (
    <>
      <section>
        {isEmpty(getItemsList) ? (
          <span className="mr-auto 2xl:w-[100%] xl:w-[95%] lg:w-[90%] py-3 absolute top-[50%] mt-10 text-black text-xl flex flex-col justify-center items-center">
            <TbClockCancel size={60} />
            <p>سامانه بسته می باشد</p>
          </span>
        ) : (
          <div className="space-y-10">
            {/* ✅ بخش طلاها (T) */}
            {goldItems.length > 0 && (
              <div className="lg:w-[88%] xl:w-[95%] 2xl:w-[100%] float-left">
                <h2 className="text-center text-lg font-bold text-amber-700 mb-4 bg-amber-50 py-2 rounded">
                  طلاها
                </h2>
                <table className="w-full">
                  <thead className="text-sm font-medium text-black border-b-[1px] border-[#A79B81] bg-amber-50">
                    <tr>
                      <th className="py-3">نام محصول</th>
                      <th className="py-3">خرید شما</th>
                      <th className="py-3">فروش شما</th>
                      <th className="py-3">آخرین آپدیت</th>
                    </tr>
                  </thead>
                  <tbody className="text-lg divide-y divide-amber-200">
                    {goldItems.map((_item) => (
                      <ListUi
                        key={_item.id}
                        roleName={roleName}
                        _item={_item}
                        userInfo={userInfo}
                        data={data}
                        setData={setData}
                        confirmModal={confirmModal}
                        setConfirmModal={setConfirmModal}
                        resultModal={resultModal}
                        setResultModal={setResultModal}
                        statePrice={statePrice}
                        setStatePrice={setStatePrice}
                        handlePriceChange={handlePriceChange}
                        stateWeight={stateWeight}
                        setStateWeight={setStateWeight}
                        handleWeightChange={handleWeightChange}
                        stateTotal={stateTotal}
                        setStateTotal={setStateTotal}
                        handleTotalChange={handleTotalChange}
                        description={description}
                        setDescription={setDescription}
                        addCommas={addCommas}
                        type={type}
                        setType={setType}
                        handlePostTransaction={handlePostTransaction}
                        setProduct_name={setProduct_name}
                        setCustomeruser={setCustomeruser}
                        setBos={setBos}
                        setIs_orderi={setIs_orderi}
                        transactionId={transactionId}
                        buyTolerance={buyTolerance}
                        setBuyTolerance={setBuyTolerance}
                        sellTolerance={sellTolerance}
                        setSellTolerance={setSellTolerance}
                        handleChangeBuyPrice={handleChangeBuyPrice}
                        handleChangeSellPrice={handleChangeSellPrice}
                        handleUpdateProduct={handleUpdateProduct}
                        handleChangeBuyClosePriceProduct={
                          handleChangeBuyClosePriceProduct
                        }
                        handleChangeSellClosePriceProduct={
                          handleChangeSellClosePriceProduct
                        }
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* ✅ بخش مسکوکات (S) */}
            {coinItems.length > 0 && (
              <div className="lg:w-[88%] xl:w-[95%] 2xl:w-[100%] float-left">
                <h2 className="text-center text-lg font-bold text-blue-700 mb-4 bg-blue-50 py-2 rounded">
                  مسکوکات
                </h2>
                <table className="w-full">
                  <thead className="text-sm font-medium text-black border-b-[1px] border-[#A79B81] bg-blue-50">
                    <tr>
                      <th className="py-3">نام محصول</th>
                      <th className="py-3">خرید شما</th>
                      <th className="py-3">فروش شما</th>
                      <th className="py-3">آخرین آپدیت</th>
                    </tr>
                  </thead>
                  <tbody className="text-lg divide-y divide-blue-200">
                    {coinItems.map((_item) => (
                      <ListUi
                        key={_item.id}
                        roleName={roleName}
                        _item={_item}
                        userInfo={userInfo}
                        data={data}
                        setData={setData}
                        confirmModal={confirmModal}
                        setConfirmModal={setConfirmModal}
                        resultModal={resultModal}
                        setResultModal={setResultModal}
                        statePrice={statePrice}
                        setStatePrice={setStatePrice}
                        handlePriceChange={handlePriceChange}
                        stateWeight={stateWeight}
                        setStateWeight={setStateWeight}
                        handleWeightChange={handleWeightChange}
                        stateTotal={stateTotal}
                        setStateTotal={setStateTotal}
                        handleTotalChange={handleTotalChange}
                        description={description}
                        setDescription={setDescription}
                        addCommas={addCommas}
                        type={type}
                        setType={setType}
                        handlePostTransaction={handlePostTransaction}
                        setProduct_name={setProduct_name}
                        setCustomeruser={setCustomeruser}
                        setBos={setBos}
                        setIs_orderi={setIs_orderi}
                        transactionId={transactionId}
                        buyTolerance={buyTolerance}
                        setBuyTolerance={setBuyTolerance}
                        sellTolerance={sellTolerance}
                        setSellTolerance={setSellTolerance}
                        handleChangeBuyPrice={handleChangeBuyPrice}
                        handleChangeSellPrice={handleChangeSellPrice}
                        handleUpdateProduct={handleUpdateProduct}
                        handleChangeBuyClosePriceProduct={
                          handleChangeBuyClosePriceProduct
                        }
                        handleChangeSellClosePriceProduct={
                          handleChangeSellClosePriceProduct
                        }
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </section>
    </>
  );
};

export default PcPriceView;
